import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import CandidateSubmissionPortal from '../components/CandidateSubmissionPortal';
import '../styles/CandidateSubmission.css';

const CandidateSubmission = () => {
  const { candidateId } = useParams();
  const [searchParams] = useSearchParams();
  const [isValidLink, setIsValidLink] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const submissionYear = searchParams.get('year') || new Date().getFullYear();
  const token = searchParams.get('token');

  useEffect(() => {
    validateSubmissionLink();
  }, [candidateId, token]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateSubmissionToken = (id, year) => {
    return btoa(`${id}-${year}-submission`);
  };

  const validateSubmissionLink = () => {
    if (!candidateId) {
      setError('Invalid submission link - missing candidate ID');
      setLoading(false);
      return;
    }

    if (!token) {
      setError('Invalid submission link - missing access token');
      setLoading(false);
      return;
    }

    const expectedToken = generateSubmissionToken(candidateId, submissionYear);
    if (token !== expectedToken) {
      setError('Invalid or expired submission link');
      setLoading(false);
      return;
    }

    setIsValidLink(true);
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="submission-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Validating submission link...</p>
        </div>
      </div>
    );
  }

  if (error || !isValidLink) {
    return (
      <div className="submission-page">
        <div className="error-container">
          <div className="error-icon">⚠️</div>
          <h2>Access Denied</h2>
          <p>{error || 'Invalid submission link'}</p>
          <div className="help-text">
            <p>If you believe this is an error, please contact your District Committee on Ordained Ministry (dCOM) for assistance.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="submission-page">
      <CandidateSubmissionPortal
        candidateId={candidateId}
        submissionYear={parseInt(submissionYear)}
      />
    </div>
  );
};

export default CandidateSubmission;
